import React, { useState, useContext, useRef, useEffect } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { useUser } from '../contexts/UserContext';
import { useWeb3 } from '../contexts/Web3Context';
import SettingsPanel from './SettingsPanel';
import NotificationsPanel from './NotificationsPanel';
import { Link } from 'react-router-dom';
import { signOut } from "firebase/auth";
import { auth } from '../firebaseConfig';
import { FaSun, FaMoon, FaCog, FaBell } from 'react-icons/fa';

const RightSidebar = () => {
  const { userData } = useUser();
  const { disconnectWallet } = useWeb3(); // Hook for wallet disconnection
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);

  // Referencia para detectar clics fuera del modal y cerrarlo
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setProfileMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [modalRef]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      const marketingAppUrl = import.meta.env.VITE_MARKETING_APP_URL || 'http://localhost:5173/';
      window.location.href = marketingAppUrl;
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <>
      <aside className="right-sidebar">
        {/* WIDGET DE PERFIL (Arriba) CON HOVER */}
        <div
          className="profile-widget"
          ref={modalRef}
          style={{ position: 'relative', marginBottom: '10px' }}
          // Eventos de Hover
          onMouseEnter={() => setProfileMenuOpen(true)}
          onMouseLeave={() => setProfileMenuOpen(false)}
        >
          <div
            className="profile-header"
            onClick={() => setProfileMenuOpen(!isProfileMenuOpen)}
            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
          >
            <img
              src={userData?.avatarUrl || '../assets/default-avatar.png'}
              alt="Avatar"
              className="user-avatar"
              style={{ width: '45px', height: '45px', borderRadius: '50%', objectFit: 'cover' }}
            />
          </div>

          {/* MINI MODAL FLOTANTE (Posicionado hacia la izquierda/adentro) */}
          {isProfileMenuOpen && (
            <div
              className="user-mini-modal"
              style={{
                position: 'absolute',
                top: '0',           // Alineado con la parte superior del avatar
                right: '60px',      // Lo empujamos a la IZQUIERDA de la barra (hacia "adentro")
                width: '150px',     // Ancho fijo para que se vea bien
                backgroundColor: theme === 'dark' ? '#2d2d3f' : '#fff', // Fondo según tema
                borderRadius: '10px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                zIndex: 1000,
                overflow: 'hidden',
                border: '1px solid rgba(128, 128, 128, 0.1)'
              }}
            >
              <div className="modal-content">
                <Link to="/perfil" className="modal-item" style={{ display: 'block', padding: '10px 15px', textDecoration: 'none', color: 'inherit' }}>
                  <span className="item-text">Perfil</span>
                </Link>

                <div className="separator" style={{ height: '1px', background: 'rgba(128,128,128,0.2)', margin: '0' }}></div>

                <a
                  href="/"
                  onClick={(e) => { e.preventDefault(); handleLogout(); }}
                  className="modal-item logout"
                  style={{ display: 'block', padding: '10px 15px', textDecoration: 'none', color: '#ff4d4d' }}
                >
                  <span className="item-text">Cerrar Sesión</span>
                </a>
              </div>
            </div>
          )}
        </div>

        {/* ICONOS DE ACCIÓN */}
        <ul className="action-icons">
          <li>
            <button onClick={toggleTheme} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {theme === 'dark' ? <FaSun size={20} /> : <FaMoon size={20} />}
            </button>
          </li>
          <li>
            <button onClick={() => setIsSettingsOpen(true)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FaCog size={20} />
            </button>
          </li>
          <li>
            <button onClick={() => setIsNotificationsOpen(true)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FaBell size={20} />
            </button>
          </li>
        </ul>
      </aside>

      {isNotificationsOpen && <NotificationsPanel onClose={() => setIsNotificationsOpen(false)} />}
      {isSettingsOpen && <SettingsPanel onClose={() => setIsSettingsOpen(false)} />}
    </>
  );
};

export default RightSidebar;